module.exports = __webpack_public_path__ + "static/media/truck-icon.ebaa6f9c.svg";